import {minLength, required, sameAs, helpers} from 'vuelidate/lib/validators'

const MIN_LENGTH = 8

export const hasUpperCase = helpers.regex('hasUpperCase', /[A-Z]+/)
export const hasLowerCase = helpers.regex('hasLowerCase', /[a-z]+/)
export const hasNumbers = helpers.regex('hasNumbers', /[0-9]+/)
export const hasSpecialCharacters = helpers.regex('hasSpecialCharacters', /[^a-zA-Z0-9\s]+/)
export const optionalPasswordValidators = {
    minLength: minLength(MIN_LENGTH),
    hasUpperCase,
    hasLowerCase,
    hasNumbers,
    hasSpecialCharacters
}
export const passwordValidators = Object.assign({required}, optionalPasswordValidators)
export const passwordRepeatValidators = (form, field) => {
    return {
        sameAsPassword: sameAs(function () {
            return this[form][field]
        })
    }
}
export const passwordErrorMessage = (field) => {
    const errors = []
    if (typeof field.required !== 'undefined' && !field.required) errors.push('Required')
    if (typeof field.minLength !== 'undefined' && !field.minLength) errors.push(`Must contain at least ${MIN_LENGTH} characters`)
    if (typeof field.hasLowerCase !== 'undefined' && !field.hasLowerCase) errors.push('Must include at least one lower case letter [a-z]')
    if (typeof field.hasUpperCase !== 'undefined' && !field.hasUpperCase) errors.push('Must include at least one UPPER case letter [A-Z]')
    if (typeof field.hasNumbers !== 'undefined' && !field.hasNumbers) errors.push('Must include at least one number [0-9]')
    if (typeof field.hasSpecialCharacters !== 'undefined' && !field.hasSpecialCharacters) errors.push('Must include at least one special symbol [@-_!?]')
    return errors.join("\n")
}
export const passwordRepeatErrorMessage = (field) => {
    const errors = []
    if (typeof field.sameAsPassword !== 'undefined' && !field.sameAsPassword) errors.push('Passwords must be identical')
    return errors.join("\n")
}